import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler, HttpHeaderResponse,
  HttpInterceptor,
  HttpProgressEvent,
  HttpRequest,
  HttpResponse, HttpSentEvent,
  HttpUserEvent,
} from '@angular/common/http';
import { Injectable, Injector, isDevMode } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { NbAuthJWTToken } from '@nebular/auth';
import 'rxjs/add/observable/fromPromise';
// Observable.throw is not a function -> https://github.com/ReactiveX/rxjs/issues/1866
import 'rxjs/add/observable/throw';
import { Observable } from 'rxjs/Observable';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptorCrypto implements HttpInterceptor {

  constructor(private injector: Injector, private router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any>> {
    return this.authService.getToken()
      .pipe(
        switchMap((token: NbAuthJWTToken) => {
          if (token.isValid()) {
            // Only add to known domains since we don't want to send our tokens to just anyone.
            // Also, Auth server API fails when the request includes a token.
            // https://codingthesmartway.com/angular-4-3-httpclient-accessing-rest-web-services-with-angular/
            if ((request.urlWithParams === environment.auth_token_endpoint)
              || (request.urlWithParams === environment.service_security_registration)
              || (request.urlWithParams === environment.service_security_request_password)
              || (request.urlWithParams === environment.service_security_reset_password)) {
              if (isDevMode()) {
                console.log('[AuthInterceptorCrypto] Auth token request, skipping...');
              }
            } else if (request.urlWithParams.indexOf(environment.service_base) > -1) { // -1 by bylo pro uplne jinou domenu, kam nechceme posilat token
              // https://github.com/akveo/nebular/blob/master/src/framework/auth/services/interceptors/jwt-interceptor.ts
              if (isDevMode()) {
                console.log('[AuthInterceptorCrypto] Adding token=' + JSON.stringify(token));
              }
              const TOKEN = `Bearer ${token.getValue()}`;
              request = request.clone({
                setHeaders: {
                  Authorization: TOKEN,
                },
              });
            } else {
              console.log('[AuthInterceptorCrypto] Wrong domain!');
            }
          }
          // https://www.intertech.com/Blog/angular-4-tutorial-handling-refresh-token-with-new-httpinterceptor/
          return next.handle(request).catch((error) => {
            console.log('[AuthInterceptorCrypto] Error=' + JSON.stringify(error));
            if (error instanceof HttpErrorResponse) {
              switch ((error as HttpErrorResponse).status) {
                case 400:
                  if (isDevMode()) {
                    console.log('[AuthInterceptorCrypto] 400 Error' + JSON.stringify(request));
                  }
                  return Observable.throw(error);
                // return next.handle(request);
                // return this.handle400Error(error);
                //     break;
                case 401:
                  if (isDevMode()) {
                    console.log('[AuthInterceptorCrypto] 401 Error' + JSON.stringify(request));
                  }
                  // Logout when session inactive
                  this.authService.logout('email').subscribe((nextLogout) => {
                    if (isDevMode()) {
                      console.log('Logout OK.');
                    }
                    this.router.navigate([ 'auth/login' ]);
                  }, (errorLogout) => {
                    if (isDevMode()) {
                      console.log('Logout Error!');
                    }
                  });
                  return Observable.throw(error);
                // return next.handle(request);
                // return this.handle401Error(req, next);
                // break;
                case 403:
                  if (isDevMode()) {
                    console.log('[AuthInterceptorCrypto] 403 Error' + JSON.stringify(request));
                  }
                  // return next.handle(request);
                  return Observable.throw(error);
                // return this.handle401Error(req, next);
                // break;
                case 404:
                  if (isDevMode()) {
                    console.log('[AuthInterceptorCrypto] 404 Error' + JSON.stringify(request));
                  }
                  // return next.handle(request);
                  return Observable.throw(error);
                // return this.handle401Error(req, next);
                // break;
                case 500:
                  if (isDevMode()) {
                    console.log('[AuthInterceptorCrypto] 500 Error' + JSON.stringify(request));
                  }
                  // return next.handle(request);
                  return Observable.throw(error);
                // return this.handle401Error(req, next);
                // break;
                default:
                  console.log('[AuthInterceptorCrypto] Unknown Error' + JSON.stringify(request));
                  Observable.throw(error);
              }
            } else {
              console.log('[AuthInterceptorCrypto] Not a HttpErrorResponse response');
              return Observable.throw(error);
            }
          });
        }),
      );
  }

  protected get authService(): NbAuthService {
    // Maximum Call Stack Size Exceeded.
    // https://github.com/angular/angular/issues/18224
    // constructor(private authService: NbAuthService) {
    // }
    return this.injector.get(NbAuthService);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/auth-crypto/auth-interceptor-crypto.service.ts